module.exports = __webpack_public_path__ + "static/media/emj13.da1797fe.svg";